module.exports = __webpack_public_path__ + "img/end_word.d63e3955.png";